export default "__VITE_ASSET__Dqh_k_Wc__"